import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Search, ChevronRight } from "lucide-react";
import { getRkOutlets } from "../../network/externalApi";
import RkAccountMenu from "../../components/RkAccountMenu/RkAccountMenu";
import styles from "./MarkReturn.module.scss";

const SEARCH_DEBOUNCE_MS = 300;

const MarkReturn = () => {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const [outlets, setOutlets] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    const trimmed = keyword.trim();
    const t = setTimeout(async () => {
      setIsLoading(true);
      setError("");
      try {
        const resp = await getRkOutlets(trimmed ? { keyword: trimmed } : {});
        if (cancelled) return;
        setOutlets(resp?.data?.response?.Outlets ?? []);
      } catch (err) {
        if (cancelled) return;
        setError(
          err?.response?.data?.message ||
            err?.message ||
            "Failed to load outlets"
        );
        setOutlets([]);
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    }, SEARCH_DEBOUNCE_MS);

    return () => {
      cancelled = true;
      clearTimeout(t);
    };
  }, [keyword]);

  const showEmpty = !isLoading && !error && outlets.length === 0;

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <button
          type="button"
          className={styles.iconButton}
          onClick={() => navigate(-1)}
          aria-label="Go back"
        >
          <ArrowLeft size={18} />
        </button>
        <h1 className={styles.title}>Mark return</h1>
        <RkAccountMenu buttonClassName={styles.iconButton} />
      </div>

      <div className={styles.content}>
        <div className={styles.searchRow}>
          <span className={styles.searchIcon}>
            <Search size={18} />
          </span>
          <input
            className={styles.searchInput}
            type="text"
            placeholder="Search by train name"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
          />
        </div>

        {isLoading ? (
          <div className={styles.stateText}>Loading outlets…</div>
        ) : error ? (
          <div className={`${styles.stateText} ${styles.errorText}`}>{error}</div>
        ) : showEmpty ? (
          <div className={styles.stateText}>No outlets found</div>
        ) : (
          outlets.map((o, idx) => (
            <button
              key={`${o.OutletName}-${idx}`}
              type="button"
              className={styles.outletCard}
              onClick={() => {
                const outletId =
                  o.OutletId ?? o.outlet_id ?? o.Id ?? o.id;
                if (outletId == null) return;
                navigate(`/rk/outlets/${outletId}/orders`, {
                  state: {
                    outletId,
                    outletName: o.OutletName,
                  },
                });
              }}
            >
              <div className={styles.outletBody}>
                <span className={styles.outletName}>{o.OutletName}</span>
                {o.Address ? (
                  <span className={styles.outletAddress}>
                    {o.Address}
                  </span>
                ) : null}
              </div>
              <span className={styles.outletChevron}>
                <ChevronRight size={18} />
              </span>
            </button>
          ))
        )}
      </div>
    </div>
  );
};

export default MarkReturn;
